import type { ReactNode } from 'react';

export function Spinner({ large = false }: { large?: boolean }): ReactNode {
  return <span className={large ? 'spinner lg' : 'spinner'} role="status" aria-label="Loading" />;
}

export function LoadingBlock({ label = 'Loading…' }: { label?: string }): ReactNode {
  return (
    <div className="spinner-block">
      <Spinner />
      <span>{label}</span>
    </div>
  );
}
